export default __webpack_public_path__ + "static/media/white_video.fe76b260.svg";